module.exports = __webpack_public_path__ + "static/img/Aions_Mar_4.dcb2342.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Aions_Mar/Aions_Mar_4.png
// module id = stuA
// module chunks = 19